import { useDropBoxUpload } from "client/hooks/upload/useDropBoxUpload";
import { HandleFile } from "client/types/HandleFile";
import { UploadOptions } from "client/types/UploadOptions";
import { DropBoxIcon } from "components/common/Icons/DropBoxIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";

export interface DropboxUploadProps {
    handleFile: HandleFile;
    options: UploadOptions;
    isOpen: boolean;
}

export const DropboxUpload = ({ handleFile, options, isOpen }: DropboxUploadProps) => {
    const { handleClick, isLoading } = useDropBoxUpload(handleFile, options, isOpen);

    return (
        <div
            className="flex items-center gap-2 py-3.5 pl-4 pr-12 dark:bg-darkSurface-200 hover:bg-gray-200 dark:hover:bg-darkSurface-300"
            onClick={(e) => {
                e.stopPropagation();
                options.onClick && options.onClick();
                handleClick();
            }}
            data-data-testid="dropbox-upload"
        >
            {isLoading ? (
                <Loader className="stroke-[var(--dark-gray)]" height={14} width={14} />
            ) : (
                <DropBoxIcon height={14} width={14} />
            )}
            <div className="capitalize">
                <Translate keyName="from-dropbox" />
            </div>
        </div>
    );
};
